import React from 'react';
import ChatPanel from '../../../../components/chat';

function ConversationsMobile() {
  return <ChatPanel isMobile />;
}

export default ConversationsMobile;
